import { request } from "../../proto/bundle";
import { getConnectionPool } from "../../core/connectionPool";
import { User } from "./user";
import { Organization } from "./orgnization";
import { checkMigrate } from "../../init/sdkInit";
import { hashString } from "../../utils/hash";

// Add User/Org -> Verify User/Org -> Start payment -> Finish Payment

async function sendSignInReq(req: request.Request): Promise<[string, string, string]> {
    const pool = await getConnectionPool();
    const AddUserResp = await pool.sendAndWait(req);
    checkMigrate(AddUserResp.addUser.status)

    if (AddUserResp.addUser?.status !== 0) {
        throw new Error(AddUserResp.addUser?.message || "Sign-Up failed");
    }

    if ((AddUserResp.addUser?.email ?? "") === "") {
        throw new Error("No email in response for SignUp(Add User)");
    }

    return [
        AddUserResp.addUser?.email ?? "",
        AddUserResp.addUser?.totpUri ?? "",
        AddUserResp.addUser?.organization ?? "",

    ] as [string, string, string];
}

export async function addUserByEmail(
    email: string,
    password: string,
    plan: number,
): Promise<User> {
    const hashed_password = await hashString(password)
    const addUser = request.AddUser.create({ email, password: hashed_password, plan: plan });
    const req = request.Request.create({ id: null, reqCreateTime: Date.now(), addUser });

    const [emailResp, totpUri,] = await sendSignInReq(req);

    return Promise.resolve(new User(emailResp, totpUri, [], "", "", "", "", "", "", 0, ""));
}

export async function addOrgByEmail(
    organization: string,
    email: string,
    password: string,
    plan?: number,
): Promise<Organization> {
    const hashed_password = await hashString(password)
    const addOrganization = request.AddOrganization.create({ email, password: hashed_password, organization, plan: plan });
    const req = request.Request.create({ id: null, reqCreateTime: Date.now(), addOrganization });

    const pool = await getConnectionPool();
    const AddOrganizationResp = await pool.sendAndWait(req);
    checkMigrate(AddOrganizationResp.addOrganization.status)

    if (AddOrganizationResp.addOrganization?.status !== 0) {
        throw new Error(AddOrganizationResp.addOrganization?.message || "Sign-Up failed");
    }

    if ((AddOrganizationResp.addOrganization?.email ?? "") === "") {
        throw new Error("No email in response for SignUp(Add User)");
    }
    const emailResp = AddOrganizationResp.addOrganization?.email ?? "";
    const totpUri = AddOrganizationResp.addOrganization?.totpKey ?? "";
    const organizationName = AddOrganizationResp.addOrganization?.organization ?? "";
    return Promise.resolve(new Organization(emailResp, organizationName, totpUri, "", "", "", "", "", new Uint8Array, plan, new Uint8Array, "",undefined));
}

export async function addUserByToken(
    organization: string,
    email: string,
    password: string,
    token: string
): Promise<User> {
    const hashed_password = await hashString(password)
    const addUser = request.AddUser.create({ email, password: hashed_password, organization, token });
    const req = request.Request.create({ id: null, reqCreateTime: Date.now(), addUser });

    const [emailResp, totpUri, organizationName] = await sendSignInReq(req);

    return Promise.resolve(new User(emailResp, totpUri, [], "", "", "", organizationName, "", "", 0, ""));
}
